import { IActiveCountryMap } from 'interfaces';
import React from 'react';
import { FGStack } from '@fg/design-system';
import RightArrow from 'assets/svg/arrow_right.svg?react';
import { LegendLabel, SortLegendCountries } from './SortLegendComponents';

type Props = {
    selectedCountries?: number[];
    licencedCountries?: IActiveCountryMap;
};

export const SortByDeltaLegend = React.memo(
    ({ selectedCountries, licencedCountries}: Props) => {
        return (
            <div style={{ marginTop: 37, marginBottom: 48, marginLeft: 8 }}>
                <FGStack
                    alignItems="center"
                    gap={8}
                    style={{ flexWrap: 'wrap' }}>
                    <DeltaLegendShapes
                        innerBg="#FD413E"
                        outerBg="#FF939333"
                        direction="up"
                    />
                    <LegendLabel>Increasing</LegendLabel>
                    <RightArrow />
                    <DeltaLegendShapes
                        innerBg="#03F9B4"
                        outerBg="#7EFFDC33"
                        direction="down"
                    />
                    <LegendLabel>Decreasing</LegendLabel>
                    <SortLegendCountries
                        selectedCountries={selectedCountries}
                        licencedCountries={licencedCountries}
                    />
                </FGStack>
            </div>
        );
    }
);

const DeltaLegendShapes = React.memo(
    ({
        innerBg,
        outerBg,
        direction,
    }: {
        innerBg?: string;
        outerBg?: string;
        direction: 'up' | 'down';
    }) => {
        const innerRadius = 12;
        const borderWidth = 4;
        const outerRadius = innerRadius + borderWidth * 2;
        const baseScale = 10;
        // 1.33 and 0.67 are taken from Figma
        const triangleWidth = 1.33 * baseScale;
        const triangleHeight = 0.67 * baseScale;
        return (
            <FGStack alignItems="center" gap={4}>
                <div
                    style={{
                        width: outerRadius,
                        height: outerRadius,
                        borderRadius: '50%',
                        backgroundColor: outerBg,
                        position: 'relative',
                    }}>
                    <div
                        style={{
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: innerRadius,
                            height: innerRadius,
                            borderRadius: '50%',
                            backgroundColor: innerBg,
                        }}
                    />
                </div>
                <div
                    style={{
                        width: 0,
                        height: 0,
                        borderLeft: `${triangleWidth / 3}px solid transparent`,
                        borderRight: `${triangleWidth / 3}px solid transparent`,
                        borderBottom: `${triangleHeight}px solid ${innerBg}`,
                        transform:
                            direction === 'down' ? 'rotate(180deg)' : undefined,
                    }}
                />
            </FGStack>
        );
    }
);
